import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-807",
  "use": "icon-807-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-807\" viewBox=\"0 0 16 16\" id=\"icon-807\">\n  <path d=\"M9.555.154C9.513.145 9.47.142 9.426.134A7.983 7.983 0 0 0 8.795.04 8 8 0 1 0 8 16a7.955 7.955 0 0 0 .795-.04c.214-.021.423-.057.631-.094.043-.008.087-.011.13-.02a7.998 7.998 0 0 0 0-15.692zm.113 15.158A7.5 7.5 0 1 1 8 .5a7.44 7.44 0 0 1 1.668.189 8.497 8.497 0 0 0 0 14.623z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol